import angular from 'angular';
import components from './components';

export default angular.module('scenes.loanInformationFields', [components])
  .name;
